import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';
import {
    getIsBitSet,
    type ListViewBitFlagsMasks,
} from 'owa-bit-flags/lib/utils/listViewBitFlagsUtil';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import { initializeDynamicLayout, LayoutChangeSource } from 'owa-layout';
import { areDisplayAdsShown } from 'owa-mail-ads-checker';
import { initializeMailOrganizationSettings } from 'owa-mail-organization-settings';
import { initializeMailOrganizationViewTypes } from 'owa-mail-organization-viewtypes-settings';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { setShowFolderPane } from '../actions/setShowFolderPane';
import logFolderPaneState from '../helpers/logFolderPaneState';
import { default as setFolderPaneWidth } from '../legacyActions/setFolderPaneWidth';
import { initializeFavoritesPaneHeightMutator } from '../mutators/favoritesPaneHeightMutators';
import initializeListViewColumnWidths from '../mutators/initializeListViewColumnWidths';
import initializeSingleLineViewWithRightReadingPane from '../mutators/initializeSingleLineWithRightReadingPane';
import { setShowAllAccountsNodeMutator } from '../mutators/setShowAllAccountsNodeMutator';
import getValidFolderPaneWidth from './getValidFolderPaneWidth';
import { initializeAnimations } from './initializeAnimations';
import { shouldShowAllAccountsNode } from './shouldShowAllAccountsNode';

export function initializeMailLayout(): void {
    /**
     * On init try to validate the folder pane width (NavigationBarWidth)
     */
    const storedFolderPaneWidth = getValidFolderPaneWidth(
        getUserConfiguration().UserOptions?.NavigationBarWidth,
        LayoutChangeSource.Init
    );

    // Set folder pane width
    setFolderPaneWidth(storedFolderPaneWidth);

    const showFolderPane = !getIsBitSet(4, getGlobalSettingsAccountMailboxInfo());
    setShowFolderPane(showFolderPane);
    logFolderPaneState(LayoutChangeSource.Init, showFolderPane, showFolderPane);

    initializeListViewColumnWidths();
    initializeFavoritesPaneHeightMutator();
    initializeSingleLineViewWithRightReadingPane();
    initializeAnimations();

    initializeDynamicLayout(areDisplayAdsShown());

    initializeMailOrganizationSettings();

    if (isGlobalFeatureEnabled('rp-momocoSettings')) {
        initializeMailOrganizationViewTypes();
    }

    if (isGlobalFeatureEnabled('acct-unifiedInbox')) {
        // UnifiedInbox does not belong to any specific account; the state is persisted via local
        // storage. The default (and admin-forced) value is resolved from the OCPS UnifiedInbox
        // policy on the global settings account, falling back to the local-storage value.
        setShowAllAccountsNodeMutator(shouldShowAllAccountsNode());
    }
}
